import { TRACKERS } from "@/constants/Trackers";
import { HealthMaintenance } from "@/features/Patient/MedicalRecords/HealthMaintenance/HealthMaintenance";
import { trackEvent } from "@/lib/tracking";
import {
  LifestyleQuestionnaireTypes,
  MentalHealthQuestionnaireTypes,
} from "@/types/questionnaires";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  openQuestionnaire: z.string().optional(),
  questionnaireResponseId: z.string().optional(),
  questionnaireType: z
    .union([
      z.nativeEnum(LifestyleQuestionnaireTypes),
      z.nativeEnum(MentalHealthQuestionnaireTypes),
    ])
    .optional(),
});

export const Route = createFileRoute("/patient/$patientId/health-maintenance")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_HEALTH_MAINTENANCE);
  },
});

function RouteComponent() {
  return <HealthMaintenance />;
}
